import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `http://ewqivah.cn/${item.href}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="py-3 md:py-4">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <ol className="flex items-center gap-2 text-sm flex-wrap">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1">
            <i className="ri-home-4-line" />
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs" />
            {item.href ? (
              <Link
                to={item.href}
                className={`${
                  index === items.length - 1
                    ? 'text-foreground-800 font-medium'
                    : 'text-foreground-500 hover:text-primary-500'
                } transition-colors`}
                aria-current={index === items.length - 1 ? 'page' : undefined}
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}